export default "__VITE_ASSET__72fae53a__"